import moment from "moment";
export var formatLongDate = function formatLongDate(date) {
  // Accepts ISO Date and returns
  // "Wednesday, March 27, 2024" Format
  var formattedDate = moment(date).format("dddd, MMMM D, YYYY");
  return formattedDate;
};